export default __webpack_public_path__ + "static/Border-Blue-Bottom-8242389025fafb00491b9d6dace51725.png";